import client from "../config/axiosConfig";

export const getVitalsReportApi = (payload) => client.post("/vitals", payload);
export const getVitalsListApi = () => client.get("/vitals");
